import { TemplateType } from "../types"

// returns true for eks + app combined template and for pure environment templates
export const isEnvironmentTemplate = (creatingCluster: boolean, templateType: TemplateType) => {
    return creatingCluster || templateType === "environment"
}